<dx-drop-down-button 
    class="ml-2 navbar-button"
    [height]="32" stylingMode="contained"
    [text]="'REPORTS.PRINT_SINGLE' | translate"
    icon="print"
    [items]="downloadFormats"
    displayExpr="name"
    keyExpr="value"
    (onItemClick)="onItemClick($event)"
></dx-drop-down-button>